var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVirtualization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,60V26A2.7528,2.7528,0,0,0,68,23.25H62v1.5h6A1.25116,1.25116,0,0,1,69.25,26V55.25H10.75V26A1.25116,1.25116,0,0,1,12,24.75h6v-1.5H12A2.7528,2.7528,0,0,0,9.25,26V60A2.7528,2.7528,0,0,0,12,62.75H39.25v2.5H30v1.5H50v-1.5H40.75v-2.5H68A2.7528,2.7528,0,0,0,70.75,60ZM12,61.25A1.25116,1.25116,0,0,1,10.75,60V56.75h58.5V60A1.25116,1.25116,0,0,1,68,61.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52,48.75a.7502.7502,0,0,0,.75-.75V32a.7502.7502,0,0,0-.75-.75H28a.7502.7502,0,0,0-.75.75V48a.7502.7502,0,0,0,.75.75Zm-23.25-16h22.5v14.5H28.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 51.25,
    width: 28,
    height: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.75,23A5.75639,5.75639,0,0,0,53,17.25a5.6049,5.6049,0,0,0-2.47266.57324,10.74275,10.74275,0,0,0-20.334-2.20312A6.636,6.636,0,0,0,28,15.25a6.75,6.75,0,0,0,0,13.5H53A5.75639,5.75639,0,0,0,58.75,23ZM53,27.25H28a5.25,5.25,0,0,1,0-10.5,5.1865,5.1865,0,0,1,2.27832.52686.75049.75049,0,0,0,1.03223-.41993,9.24178,9.24178,0,0,1,17.8955,2.27442.75053.75053,0,0,0,1.207.52295A4.19329,4.19329,0,0,1,53,18.75a4.25,4.25,0,0,1,0,8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVirtualization);
export default __webpack_public_path__ + "static/media/icon_virtualization.8a075e03ba1bbc0ad1d1264e3960cc31.svg";
export { ForwardRef as ReactComponent };